import { defineModule, definePermission } from '@shared/contract'

// KI-Assistent: Chat im ganzen System – eine zweite Bedienoberfläche auf derselben Aktionsschicht. Die Laufzeit
// (Schleife, Vorschläge, Bestätigung) liegt im Kern (server/kernel/ai); dieses Modul trägt die Rechte, die eigenen
// Unterhaltungen des Nutzers, die Einstellungen je Betrieb und die Aufbewahrung.
export default defineModule({
  id: 'assistant',
  title: 'KI-Assistent',
  description:
    'Assistent mit genau den Rechten des angemeldeten Mitarbeiters: liest sofort, schlägt Änderungen mit Vorschau vor und führt sie erst nach Bestätigung aus.',
  permissions: [
    definePermission({
      key: 'assistant.chat.use',
      label: 'KI-Assistent nutzen',
      group: 'KI-Assistent',
      description:
        'Mit dem Assistenten arbeiten. Er kann nur, was die übrigen Rechte der Rolle erlauben – dieses Recht gibt keine weiteren.',
      locationScoped: false,
    }),
    definePermission({
      key: 'assistant.settings.manage',
      label: 'KI-Assistent einrichten',
      group: 'KI-Assistent',
      description: 'Den Assistenten für den Betrieb ein- und ausschalten, Aufbewahrung und Monatsbudget festlegen.',
      locationScoped: false,
    }),
  ],
})
